import React from 'react';
import { useTranslation } from '@/i18n';
import { ExpertiseCard } from '../ExpertiseCard';
import { ExpertiseListProps } from './ExpertiseList.types';
import './ExpertiseList.styles.css';

export const ExpertiseList: React.FC<ExpertiseListProps> = ({
  expertises,
  onExpertiseClick,
  onFileMakerClick,
  className = '',
  showFacadeImage = true,
  showProgress = true,
  showActions = true,
  showUrgency = true,
  showFileMaker = true,
  showTaskButton = true,
  emptyStateTitle,
  emptyStateMessage,
  isSearchActive = false
}) => {
  const { t } = useTranslation();
  const listClasses = ['expertise-list', className].filter(Boolean).join(' ');

  // Use provided titles/messages or fall back to translations
  const defaultEmptyTitle = emptyStateTitle || t('expertise.list.noExpertiseFound');
  const defaultEmptyMessage = emptyStateMessage || t('expertise.list.noExpertisesToDisplay');
  const searchEmptyTitle = t('expertise.list.noResultsFound');
  const searchEmptyMessage = t('expertise.list.modifySearchOrFilters');

  if (expertises.length === 0) {
    return (
      <div className="expertise-list-empty-state">
        <h3>{isSearchActive ? searchEmptyTitle : defaultEmptyTitle}</h3>
        <p>{isSearchActive ? searchEmptyMessage : defaultEmptyMessage}</p>
      </div>
    );
  }

  return (
    <div className={listClasses}>
      {expertises.map((expertise, index) => (
        <ExpertiseCard
          key={`expertise-${expertise.stageId || 0}-${expertise.id}-${index}`}
          {...expertise}
          onClick={() => onExpertiseClick?.(expertise)}
          onFileMaker={() => onFileMakerClick?.(expertise)}
          showFacadeImage={showFacadeImage}
          showProgress={showProgress}
          showActions={showActions}
          showUrgency={showUrgency}
          showFileMaker={showFileMaker}
          showTaskButton={showTaskButton}
          className="expertise-list-item"
        />
      ))}
    </div>
  );
};